module.exports = __webpack_public_path__ + "img/about-principles.584c1db0.png";